import { Component, OnInit, ViewChild, AfterViewInit, ElementRef, Input } from '@angular/core';
import { UserPreferenceModel } from './UserPreference.model';
import { ComboBoxComponent } from '../../../combo-box/combo-box.component';
import { CheckBoxComponent } from '../../../check-box/check-box.component';
import { ButtonComponent } from '../../../button/button.component';
import { FormComponent } from '../../../form/form.component';
import { RangeBarComponent } from '../../../range-bar/range-bar.component';
import { ServiceStock } from '../../../service-stock.service';
import { RadioButtonComponent } from '../../../radio-button/radio-button.component';
import { gotxModalComponent } from 'src/app/gotxModal/gotxModal.component';
import { UserPreferenceService } from 'src/app/user-preference.service';
import { UserPreference, IndexList } from 'src/app/user-preference.model';
import { CheckboxSelectionComponent } from 'ag-grid-community';
import { MarketWatchService } from '../../../market-watch.service';
import { FillTypeComponent } from '../../components/FillType/FillType.component';

const customCss: string = '';

@Component({
    selector: 'app-UserPreference',
    templateUrl: './UserPreference.component.html'
})
export class UserPreferenceComponent extends FormComponent implements OnInit, AfterViewInit {

    @Input('userPreferenceType') userPreferenceType: string;

    @ViewChild('TickerGrp', { static: false }) TickerGrp: ElementRef;
    @ViewChild('txtUsername', { static: false }) txtUsername: ComboBoxComponent;
    // @ViewChild('rdbtnSector', { static: false }) rdbtnSector: RadioButtonComponent;
    // @ViewChild('rdbtnMyPortfolio', { static: false }) rdbtnMyPortfolio: RadioButtonComponent;
    // @ViewChild('cmbTickerCombo', { static: false }) cmbTickerCombo: ComboBoxComponent;
    @ViewChild('chkSelectAll', { static: false }) chkSelectAll: CheckBoxComponent;
    @ViewChild('chkBank', { static: false }) chkBank: CheckBoxComponent;
    @ViewChild('chkComm', { static: false }) chkComm: CheckBoxComponent;
    @ViewChild('chkCprod', { static: false }) chkCprod: CheckBoxComponent;
    @ViewChild('chkenerg', { static: false }) chkenerg: CheckBoxComponent;
    @ViewChild('chkConMat', { static: false }) chkConMat: CheckBoxComponent;
    @ViewChild('rgTickerSpeed', { static: false }) rgTickerSpeed: RangeBarComponent;
    @ViewChild('rdbtnTickerConfig', { static: false }) rdbtnTickerConfig: RadioButtonComponent;
    @ViewChild('cmbLanguage', { static: false }) cmbLanguage: ComboBoxComponent;
    @ViewChild('cmbTheme', { static: false }) cmbTheme: ComboBoxComponent;
    @ViewChild('btUpdate', { static: false }) btUpdate: ButtonComponent;
    @ViewChild('btCancel', { static: false }) btCancel: ButtonComponent;
    @ViewChild('cmbIndex1', { static: false }) cmbIndex1: ElementRef; // ComboBoxComponent;
    @ViewChild('cmbIndex2', { static: false }) cmbIndex2: ElementRef; // ComboBoxComponent;
    @ViewChild('cmbOrderType', { static: false }) cmbOrderType: ComboBoxComponent;
    @ViewChild('cmbFillType', { static: false }) cmbFillType: FillTypeComponent; // ComboBoxComponent;
    @ViewChild('chkDefault', { static: false }) chkDefault: CheckBoxComponent;
    @ViewChild('txtDefaultQty', { static: false }) txtDefaultQty: ComboBoxComponent;
    @ViewChild('cmbSector', { static: false }) cmbSector: ElementRef;

    skeletonContentLoaded = false;
    selectedSectorList: any[] = [];
    message: string;
    showForEquity = false;
    staticOptions: any[] = []; 
    indxListMaster:{indexName:string,key:number}[]=[];
   
    async revalidate(): Promise<number> {
        var totalErrors = 0;
        // super.beforeRevalidate();
        await Promise.all([
            // this.revalidateBasicField('cmbLanguage'),
            // this.revalidateBasicField('cmbTheme'),
            // this.revalidateBasicField('cmbOrderType'),
            // this.revalidateBasicField('cmbFillType'),
            // this.revalidateBasicField('txtDefaultQty'),
            // // this.revalidateBasicField('rgTickerSpeed'),
            // // this.revalidateBasicField('rdbtnTickerConfig'),
            this.validateInputs()
        ]).then((errorCounts) => {
            errorCounts.forEach((errorCount) => {
                totalErrors += errorCount;
            });
        });
        this.errors = totalErrors;
        // super.afterRevalidate();
        return totalErrors;
    }
    constructor(services: ServiceStock, private userPreferenceService: UserPreferenceService, private marketService: MarketWatchService, private indexList: IndexList) {
        super(services);
        this.value = new UserPreferenceModel();
        this.componentCode = 'UserPreference';
        this.staticOptions = [
            {"text": "Default Option", "id": "DEFAULT"}
          ];
    }
    setReadOnly(readOnly) {
        super.setBasicFieldsReadOnly(readOnly);
    }
    async onFormLoad() {
        this.setInputs(this.services.dataStore.getData(this.services.routing.currModal));

        this.txtUsername.setValue(this.services.UserPreference.userName);
        this.txtUsername.setReadOnly(true);
        this.cmbLanguage.setValue(this.services.UserPreference.language);
        this.cmbTheme.setValue(this.services.UserPreference.themeName);
        // this.cmbIndex1.setValue(this.services.UserPreference.userPreference.indexinfo[0]);
        this.cmbIndex1.nativeElement.value = this.services.UserPreference.userPreference.indexinfo[0];
        // this.cmbIndex2.setValue(this.services.UserPreference.userPreference.indexinfo[1]);
        this.cmbIndex2.nativeElement.value = this.services.UserPreference.userPreference.indexinfo[1];
        this.rgTickerSpeed.setValue(this.services.UserPreference.tickerSpeed);
        this.rdbtnTickerConfig.setValue(this.services.UserPreference.selectedStock["stock"]); // UEI_TICKER_STOCK
        this.cmbOrderType.setValue(this.services.UserPreference.userPreference.orderentry.priceType || "LIMIT");
        this.loadFillType();
        this.cmbFillType.cmbFillType.setValue(this.services.UserPreference.userPreference.orderentry.timeinforce || "GFD");
        this.chkDefault.setValue(this.services.UserPreference.userPreference.orderentry.isqtyallowed || false);
        this.txtDefaultQty.setValue(this.services.UserPreference.userPreference.orderentry.defaultqty || 0);

        this.onChkDefault();
        this.onRbtTicker();

        this.setDependencies();
    }
    setInputs(param: any) {
        let params = this.services.http.mapToJson(param);
        if (params['mode']) {
            this.mode = params['mode'];
        }
    }
    async submitForm(path, apiCode, serviceCode) {
        this.submitData['formName'] = 'User Preference';
        await super.submit(path, apiCode, serviceCode);
    }
    getFieldInfo() {
        this.amountComponent.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
        this.comboFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
        // this.fileUploadFields.forEach(field => {this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo();});
        return this.additionalInfo;
    }
    getFieldValue() {
        return this.value;
    }
    setValue(inputValue, inputDesc = undefined) {
        this.setBasicFieldsValue(inputValue, inputDesc);
        this.value = new UserPreferenceModel();
        this.value.setValue(inputValue);
        this.setDependencies();
        this.passNewValue(this.value);
    }
    ngOnInit() {
        if (this.formCode == undefined) { this.formCode = 'UserPreference'; }
        if (this.formOnLoadError) { return; }
        setTimeout(() => {
            this.skeletonContentLoaded = true;
        }, 1000);
        var styleElement = document.createElement('style');
        styleElement.type = 'text/css';
        styleElement.innerHTML = customCss;
        styleElement.id = 'UserPreference_customCss';
        document.getElementsByTagName('head')[0].appendChild(styleElement);

        this.indxListMaster = this.services.dataStore.getData("indxListMaster");

        this.services.dataStore.currentMessage.subscribe(message => {
            this.message = message;
        });

        console.log("sel this.message",this.message);
        if(this.message == "COMDERV"){
            this.indxListMaster = this.indxListMaster['COMDERV'];
        }else{
            this.indxListMaster = this.indxListMaster['EQUITY'];
        }

        this.selectedSectorList = [];
        this.services.dataStore.stockMaster.map(item => item.sectorName)
            .filter((value, index, self) => {
                if (self.indexOf(value) === index) {
                    let item = {};
                    item['key'] = value;
                    item['value'] = false;
                    this.services.UserPreference.selectedStock["filter"].forEach(element => {
                        if (element == value) {
                            item['value'] = true;
                        }
                    });
                    this.selectedSectorList.push(item);
                }
            });

            
              console.log("this.message new",this.message);
              if(this.message == "EQUITY"){
                this.staticOptions = [{"text":"MyPortfolio","id":"MYPORTFOLIO"}, {"text":"Sector","id":"SECTOR"}];
              }else if(this.message == "COMDERV"){
                this.staticOptions = [{"text":"COMWATCH","id":"COMWATCH"}];
              }else if(this.message == "FUTOPT"){
                this.staticOptions = [{"text":"FOWATCH","id":"FOWATCH"}];
              }else if(this.message == "ALL"){
                this.staticOptions = [{"text":"MyPortfolio","id":"MYPORTFOLIO"}, {"text":"Sector","id":"SECTOR"},{"text":"COMWATCH","id":"COMWATCH"}];
              }
              
            
            
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        var styleElement = document.getElementById('UserPreference_customCss');
        styleElement.parentNode.removeChild(styleElement);
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.subsBFldsValueUpdates();
            this.onFormLoad();
            this.checkForHTabOverFlow();
        });
    }
    clearError() {
        super.clearBasicFieldsError();
        super.clearHTabErrors();
        super.clearVTabErrors();
        this.errors = 0;
        this.errorMessage = [];
    }
    onReset() {
        super.resetBasicFields();
        this.clearHTabErrors();
        this.clearVTabErrors();
        this.errors = 0;
        this.errorMessage = [];
        this.additionalInfo = undefined;
        this.dependencyMap.clear();
        this.value = new UserPreferenceModel();
        this.passNewValue(this.value);
        this.setReadOnly(false);
        this.onFormLoad();
    }
    onChkDefault() {
        this.txtDefaultQty.setReadOnly(!this.chkDefault.getFieldValue());
    }
    async btnSave_click() {
        // validations
        var errorCount: number = await this.revalidate();
        if (errorCount == 0) {
            // assign values to Service
            this.services.UserPreference.language = this.cmbLanguage.getFieldValue();
            this.services.UserPreference.themeName = this.cmbTheme.getFieldValue();
            this.services.UserPreference.userPreference.indexinfo[0] = this.cmbIndex1.nativeElement.value; // this.cmbIndex1.getFieldValue();
            this.services.UserPreference.userPreference.indexinfo[1] = this.cmbIndex2.nativeElement.value; // this.cmbIndex2.getFieldValue();
            this.services.UserPreference.tickerSpeed = this.rgTickerSpeed.getFieldValue();
            this.services.UserPreference.selectedStock["stock"] = this.rdbtnTickerConfig.getFieldValue();
            this.services.UserPreference.selectedStock["filter"] = this.getFilterSectorList();
            this.services.UserPreference.userPreference.orderentry.priceType = this.cmbOrderType.getFieldValue();
            this.services.UserPreference.userPreference.orderentry.timeinforce = this.cmbFillType.cmbFillType.getFieldValue();
            this.services.UserPreference.userPreference.orderentry.isqtyallowed = this.chkDefault.getFieldValue();
            this.services.UserPreference.userPreference.orderentry.defaultqty = this.txtDefaultQty.getFieldValue();

            // save to D/b
            this.userPreferenceService.saveUserPreference();

            if (this.userPreferenceService.retValue == 0) {
                this.showMessage('errMsgDiv1', this.services.transalte('UserPreference.msgSaveSuccess'));
            } else {
                this.showMessage('errMsgDiv1', this.services.transalte('UserPreference.msgSaveFail'));
            }

            // apply Preference
            if (this.userPreferenceService.retValue == 0) {
                this.services.translate.use(this.userPreferenceService.getIwsLang() || this.services.UserPreference.language);

                localStorage.setItem('THEME_MODE', this.userPreferenceService.getIwsTheme() || this.services.UserPreference.themeName);
                this.services.theme.setDarkThemeMode();

                // Index - On Next Login // this.services.dataStore.setData("defaultIndex", this.services.UserPreference.userPreference.indexinfo.join());

                // OE Setting - ref. to OrderEntry_New.component.ts //

                // Ticker Setting - ref. to gotx-market-watch.component.ts > getTickerInfo() //

                this.showMessage('errMsgDiv1', this.services.transalte('UserPreference.msgApplySuccess'));
            }
        }
    }
    showMessage(id, message) {
        document.getElementById(id).innerHTML = message;
        setTimeout(() => {
            if (document.getElementById(id)) document.getElementById(id).innerHTML = "";
        }, 3000);
    }
    protected validateInputs() {
        var totalErrors = 0;
        var value: any;
        let msg = this.services.transalte('ErrorCodes.MANDATORY'); // "Value cannot be empty"

        value = this['cmbLanguage'].value;
        if (value == undefined || value.toString() == '' || value.length == 0) {
            this['cmbLanguage'].setError(msg);
            return ++totalErrors;
        }

        value = this['cmbTheme'].value;
        if (value == undefined || value.toString() == '' || value.length == 0) {
            this['cmbTheme'].setError(msg);
            return ++totalErrors;
        }

        value = this['cmbOrderType'].value;
        if (value == undefined || value.toString() == '' || value.length == 0) {
            this['cmbOrderType'].setError(msg);
            return ++totalErrors;
        }

        value = this['cmbFillType'].cmbFillType.value;
        if (value == undefined || value.toString() == '' || value.length == 0) {
            this['cmbFillType'].setError(msg);
            return ++totalErrors;
        }

        value = this['txtDefaultQty'].value;
        if (value == undefined || value.toString() == '' || value.length == 0) {
            this['txtDefaultQty'].setError(msg);
            return ++totalErrors;
        }

        return totalErrors;
    }

    async cmbOrderType_change(event) {
        this.loadFillType();
    }
    async loadFillType() {
        let fillType = this.services.dataStore.getFillType("NR", this.cmbOrderType.getFieldValue(),this.message);

        this.cmbFillType.cmbFillType.dropDownOptions.Options = [{ id: undefined, text: this.cmbFillType.cmbFillType.placeholder }];
        this.cmbFillType.cmbFillType.dropDownOptions.Options = this.cmbFillType.cmbFillType.dropDownOptions.Options.concat(fillType);

        this.cmbFillType.cmbFillType.setValue(fillType[0].id);
    }

    onRbtTicker() {
        // if (this.rdbtnTickerConfig.getFieldValue() == "SECTOR") {
        //     this.cmbSector.nativeElement.disabled = false;
        // } else {
        //     this.cmbSector.nativeElement.disabled = true;
        // }
    }

    cmbSectorChecked($event: any, sector: any) {
        this.selectedSectorList.forEach(element => {
            if (element.key == sector.key) {
                element.value = $event.target.checked;
            }
        });
    }

    getFilterSectorList() {
        let retValue: any[] = [];
        // if (this.services.UserPreference.selectedStock["stock"] == "SECTOR") {
            this.selectedSectorList.forEach(element => {
                if (element.value) {
                    retValue.push(element.key);
                }
            });
        // }
        return retValue;
    }

}